module["exports"] = [
  "ДОО",
  "ДООЕЛ",
  "АД",
  "ТП"
];
